import React from 'react';
import { lazyImport } from '@/utils/lazyImport';
const { LogIn } = lazyImport(() => import('@/features/auth'), 'LogIn');
const { SignUp } = lazyImport(() => import('@/features/auth'), 'SignUp');

export const publicRoutes = [
  { path: '/login', element: <LogIn /> },
  { path: '/signup', element: <SignUp /> },
];
